import Model from './Model';

export default class ComponentVariation extends Model {
  static type = 'componentVariations';

  name: string;
  color: string
  price: number;

	static default():any{

		return {
			material: {
				configuration: {
					rougheness: 0.5,
					metalness: 0.5,
				}

			}, color: '#000000',

		}
}

}
